import Call from '../Call';
import {objToQs} from "../Utils";

const PartnerDomains = {
    get(filters) {
        return Call(`partnerDomains?${objToQs(filters)}`);
    },
    update(id, entity) {
        return Call(`partnerDomains/${id}`,'PUT', entity);
    },
    remove(id) {
        return Call(`partnerDomains/${id}`,'DELETE');
    },
};

export default PartnerDomains;


// WEBPACK FOOTER //
// ./src/services/API/components/PartnerDomains.js